<template>
  <v-container
    data-vue-component-name="Introduce"
    class="justify-center"
    fill-height
    fluid
  >
    <v-card
      flat
      max-width="500"
      class="d-flex flex-column align-center"
    >
      <v-img
        class="rounded-circle"
        :src="imageUrl"
        width="200"
        height="200"
      />

      <v-card-title>{{ getIntroduce.title }}</v-card-title>

      <v-card-text class="text-center">
        {{ getIntroduce.description }}
      </v-card-text>

      <v-btn class="text-capitalize" @click="toNextPage">Continue</v-btn>
    </v-card>
  </v-container>
</template>

<script>
import onSpace from '@/mixins/onSpace';

export default {
  name: 'Introduce',
  mixins: [onSpace],
  data: () => ({
    imageUrl: 'https://img5.goodfon.ru/wallpaper/big/0/55/hohentauern-avstriia-priroda-peizazh-gory-lesa-zima-doma-kom.jpg',
    onSpaceHandler: 'toNextPage',
  }),
  computed: {
    getIntroduce() {
      return this.$store.getters.getIntroduce;
    },
  },
  methods: {
    toNextPage() {
      this.$store.commit('SET_CURRENT_STEP', 1);
      this.$router.push({ name: this.$store.getters.getStepView });
    },
  },
};
</script>
